import * as trace from 'owa-trace';
import ExecuteSearchJsonResponse from 'owa-service/lib/contract/ExecuteSearchJsonResponse';
import executeSearchOperation from 'owa-service/lib/operation/executeSearchOperation';
import executeSearchRequest from 'owa-service/lib/factory/executeSearchRequest';
import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';
import ItemTypesFilter from 'owa-service/lib/contract/ItemTypesFilter';
import mapFolderIdToBaseSearchScope from '../helpers/mapFolderIdToBaseSearchScope';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

const MAX_RESULTS_COUNT_HINT: number = 1000; // The maximum number of results we will ever ask for.

interface ExecuteSearchParams {
    rowOffset: number;
    pageSize: number;
    queryString: string;
    sessionGuid: string;
    staticFolderScopeId: string;
    itemTypes: ItemTypesFilter;
}
/**
 * Calls ExecuteSearch in the OWA service
 * @param rowOffset rowOffset value for the results
 * @param pageSize max number of results to be returned
 * @param queryString the queryString
 * @param sessionGuid the current search session
 * @param staticFolderScopeId the scope of the current query
 * @param itemTypes the type of mail results - Item or Conversation
 */
export default async function executeSearchService({
    rowOffset,
    pageSize,
    queryString,
    sessionGuid,
    staticFolderScopeId,
    itemTypes,
}: ExecuteSearchParams): Promise<ExecuteSearchResponseMessage> {
    const jsonHeader = getJsonRequestHeader();
    jsonHeader.RequestServerVersion = 'V2016_06_15';

    try {
        const response: ExecuteSearchJsonResponse = await executeSearchOperation({
            Header: jsonHeader,
            Body: executeSearchRequest({
                ApplicationId: 'Owa',
                IdFormat: 'EwsId',
                IncludeDeleted: true, // Check if we need this to be controlled
                ItemTypes: itemTypes,
                MaxPreviewLength: 60,
                MaxRefinersCountPerRefinerType: 5,
                MaxResultsCountHint: MAX_RESULTS_COUNT_HINT,
                PropertySetName: 'Owa16',
                Query: queryString,
                ResultRowCount: pageSize,
                ResultRowOffset: rowOffset,
                RetrieveRefiners: false,
                SearchRefiners: null,
                SearchScope: mapFolderIdToBaseSearchScope(staticFolderScopeId),
                SearchRestrictions: null,
                SearchSessionId: sessionGuid,
                SortOrder: 'DateTime',
                MaxHybridCountHint: 0,
            }),
        });

        const result: ExecuteSearchResponseMessage = response?.Body;
        return result;
    } catch (error) {
        trace.errorThatWillCauseAlert(
            'ExecuteSearch: Failed to fetch mail results. ' + error.message
        );
        return null;
    }
}
